<div class="app-profile-container">
  <div class="app-profile-row">
    <div class="app-profile-title">
      @if ((appNavNarMode$ | async) === 'collapsed') {
        <button
          mat-icon-button
          (click)="toggleNavigationMenu()"
          [attr.title]="'APP.TOOLTIPS.EXPAND_NAVIGATION' | translate"
          [attr.aria-label]="'APP.TOOLTIPS.EXPAND_NAVIGATION' | translate">
          <mat-icon>menu</mat-icon>
        </button>
      }
      <button
        class="app-profile-icon"
        mat-icon-button
        (click)="navigateToPersonalFiles()"
        [attr.aria-label]="'APP.EDIT_PROFILE.GO_TO_PERSONAL_FILES_BUTTON_LABEL' | translate"
        [attr.title]="'APP.EDIT_PROFILE.GO_TO_PERSONAL_FILES_BUTTON_LABEL' | translate">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h3 class="app-profile">{{'APP.EDIT_PROFILE.MY_PROFILE' | translate}}</h3>
    </div>
  </div>
  <div class="app-profile-general-row" [formGroup]="profileForm" id="general-dropdown">
    <div class="app-profile-general">
      <div class="app-profile-general-section">
        <button
          mat-icon-button
          (click)="toggleGeneralDropdown()"
          [attr.title]="`APP.TOOLTIPS.${generalSectionDropdown ? 'COLLAPSE' : 'EXPAND'}_SECTION` | translate"
          [attr.aria-label]="`APP.TOOLTIPS.${generalSectionDropdown ? 'COLLAPSE' : 'EXPAND'}_SECTION` | translate">
          <mat-icon>{{ generalSectionDropdown ?  'expand_more' : 'chevron_right'}}</mat-icon>
        </button>
        <h4 class="app-general-title">{{'APP.EDIT_PROFILE.GENERAL' | translate}}</h4>
      </div>
      @if (generalSectionButtonsToggle) {
        <button
          mat-icon-button
          (click)="toggleGeneralButtons()"
          class="app-general-edit"
          [attr.title]="'APP.TOOLTIPS.EDIT' | translate"
          [attr.aria-label]="'APP.TOOLTIPS.EDIT' | translate">
          <mat-icon>edit</mat-icon>
        </button>
      } @else {
        <button
          mat-icon-button
          class="app-general-cancel-btn"
          [attr.title]="'APP.TOOLTIPS.CANCEL' | translate"
          [attr.aria-label]="'APP.TOOLTIPS.CANCEL' | translate"
          (click)="toggleGeneralButtons()">
          <mat-icon>close</mat-icon>
        </button>
        <button
          mat-icon-button
          color="primary"
          [attr.title]="'APP.TOOLTIPS.SAVE' | translate"
          [attr.aria-label]="'APP.TOOLTIPS.SAVE' | translate"
          [disabled]="profileForm.invalid"
          (click)="onSaveGeneralData(profileForm)">
          <mat-icon>check</mat-icon>
        </button>
      }
    </div>
    @if (generalSectionDropdown) {
      <mat-divider class="app-divider" />
      <div class="app-general-dropdown">
        <div class="app-general-dropdown-details">
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.FIRST_NAME' | translate}}</h4>
          <p class="app-profile-general-dropdown-details">{{personDetails?.firstName}}</p>
        </div>
        <mat-divider class="app-general-dropdown-divider" />
        <div class="app-general-dropdown-details">
          <h4 class="app-profile-general-dropdown-heading">{{'APP.EDIT_PROFILE.LAST_NAME' | translate}}</h4>
          <p class="app-profile-general-dropdown-details">{{personDetails?.lastName}}</p>
        </div>
        <mat-divider class="app-general-dropdown-divider" />
        <div class="app-general-dropdown-details">
          <label
            class="app-profile-general-dropdown-heading"
            for="app-view-profile-job-title">
            {{'APP.EDIT_PROFILE.JOB_TITLE' | translate}}
          </label>
          @if (generalSectionButtonsToggle) {
            <p class="app-profile-general-dropdown-details">{{personDetails?.jobTitle}}</p>
          } @else {
            <input
              type="text"
              value=""
              formControlName="jobTitle"
              class="app-profile-general-dropdown-input-details app-selected"
              id="app-view-profile-job-title">
          }
        </div>
        <mat-divider class="app-general-dropdown-divider" />
        <div class="app-general-dropdown-details">
          <label
            class="app-profile-general-dropdown-heading"
            for="app-view-profile-location">
            {{'APP.EDIT_PROFILE.LOCATION' | translate}}
          </label>
          @if (generalSectionButtonsToggle) {
            <p class="app-profile-general-dropdown-details">{{personDetails?.location}}</p>
          } @else {
            <input
              type="text"
              value=""
              formControlName="location"
              class="app-profile-general-dropdown-input-details app-selected"
              id="app-view-profile-location">
          }
        </div>
        <mat-divider class="app-general-dropdown-divider" />
        <div class="app-general-dropdown-details">
          <label
            class="app-profile-general-dropdown-heading"
            for="app-view-profile-telephone">
            {{'APP.EDIT_PROFILE.TELEPHONE' | translate}}
          </label>
          @if (generalSectionButtonsToggle) {
            <p class="app-profile-general-dropdown-details">{{personDetails?.telephone}}</p>
          } @else {
            <input
              type="tel"
              name="Telephone"
              value=""
              formControlName="telephone"
              class="app-profile-general-dropdown-input-details app-selected"
              aria-describedby="app-view-profile-phone-error-message"
              id="app-view-profile-telephone">
          }
          @if (profileForm.controls['telephone'].errors) {
            <mat-error class="app-error-message" role="alert" id="app-view-profile-phone-error-message">
              {{ 'APP.EDIT_PROFILE.INVALID_INPUT' | translate }}
            </mat-error>
          }
        </div>
        <mat-divider class="app-general-dropdown-divider" />
        <div class="app-general-dropdown-details">
          <label
            class="app-profile-general-dropdown-heading"
            for="app-view-profile-mobile">
            {{'APP.EDIT_PROFILE.MOBILE' | translate}}
          </label>
          @if (generalSectionButtonsToggle) {
            <p class="app-profile-general-dropdown-details">{{personDetails?.mobile}}</p>
          } @else {
            <input
              type="tel"
              value=""
              formControlName="mobile"
              class="app-profile-general-dropdown-input-details app-selected"
              aria-describedby="app-view-profile-mobile-error-message"
              id="app-view-profile-mobile">
          }
          @if (profileForm.controls['mobile'].errors) {
            <mat-error class="app-error-message" role="alert" id="app-view-profile-mobile-error-message">
              {{ 'APP.EDIT_PROFILE.INVALID_INPUT' | translate }}
            </mat-error>
          }
        </div>
      </div>
    }
  </div>

  <div class="app-profile-contact-row" [formGroup]="profileForm" id="contact-dropdown">
    <div class="app-profile-general profile-general-bottom-radius">
      <div class="app-profile-general-section">
         <button
          mat-icon-button
          (click)="toggleContactDropdown()"
          [attr.title]="`APP.TOOLTIPS.${contactSectionDropdown ? 'COLLAPSE' : 'EXPAND'}_SECTION` | translate"
          [attr.aria-label]="`APP.TOOLTIPS.${contactSectionDropdown ? 'COLLAPSE' : 'EXPAND'}_SECTION` | translate">
          <mat-icon>{{ contactSectionDropdown ?  'expand_more' : 'chevron_right'}}</mat-icon>
        </button>
        <h4 class="app-general-title">{{'APP.EDIT_PROFILE.COMPANY_DETAILS' | translate}}</h4>
      </div>
      @if (contactSectionButtonsToggle) {
        <button
          mat-icon-button
          (click)="toggleContactButtons()"
          class="app-general-edit"
          [attr.title]="'APP.TOOLTIPS.EDIT' | translate"
          [attr.aria-label]="'APP.TOOLTIPS.EDIT' | translate">
          <mat-icon>edit</mat-icon>
        </button>
      } @else {
        <button
          mat-icon-button
          class="app-general-cancel-btn"
          [attr.title]="'APP.TOOLTIPS.CANCEL' | translate"
          [attr.aria-label]="'APP.TOOLTIPS.CANCEL' | translate"
          (click)="toggleContactButtons()">
          <mat-icon>close</mat-icon>
        </button>
        <button
          mat-icon-button
          color="primary"
          [attr.title]="'APP.TOOLTIPS.SAVE' | translate"
          [attr.aria-label]="'APP.TOOLTIPS.SAVE' | translate"
          [disabled]="profileForm.invalid"
          (click)="onSaveCompanyData(profileForm)">
          <mat-icon>check</mat-icon>
        </button>
      }
    </div>
    @if (contactSectionDropdown) {
      <mat-divider class="app-divider" />
      <div class="app-general-dropdown">
        <div class="app-general-dropdown-details">
          <label
            class="app-profile-general-dropdown-heading"
            for="app-view-profile-company-name">
            {{'APP.EDIT_PROFILE.NAME' | translate}}
          </label>
          @if (contactSectionButtonsToggle) {
            <p class="app-profile-general-dropdown-details">{{personDetails?.company?.organization}}</p>
          } @else {
            <input
              type="text"
              value=""
              formControlName="companyName"
              class="app-profile-general-dropdown-input-details app-selected"
              id="app-view-profile-company-name">
          }
        </div>
        <mat-divider class="app-general-dropdown-divider" />
        <div class="app-general-dropdown-details">
          <label
            class="app-profile-general-dropdown-heading"
            for="app-view-profile-company-address">
            {{'APP.EDIT_PROFILE.ADDRESS' | translate}}
          </label>
          @if (contactSectionButtonsToggle) {
            <p class="app-profile-general-dropdown-details">{{personDetails?.company?.address1}}</p>
          } @else {
            <input
              type="text"
              value=""
              formControlName="companyAddress"
              class="app-profile-general-dropdown-input-details app-selected"
              id="app-view-profile-company-address">
          }
        </div>
        <mat-divider class="app-general-dropdown-divider" />
        <div class="app-general-dropdown-details">
          <label
            class="app-profile-general-dropdown-heading"
            for="app-view-profile-company-post-code">
            {{'APP.EDIT_PROFILE.POSTCODE' | translate}}
          </label>
          @if (contactSectionButtonsToggle) {
            <p class="app-profile-general-dropdown-details">{{personDetails?.company?.postcode}}</p>
          } @else {
            <input
              type="text"
              value=""
              formControlName="companyPostCode"
              class="app-profile-general-dropdown-input-details app-selected"
              id="app-view-profile-company-post-code">
          }
        </div>
        <mat-divider class="app-general-dropdown-divider" />
        <div class="app-general-dropdown-details">
          <label
            class="app-profile-general-dropdown-heading"
            for="app-view-profile-company-telephone">
            {{'APP.EDIT_PROFILE.TELEPHONE' | translate}}
          </label>
          @if (contactSectionButtonsToggle) {
            <p class="app-profile-general-dropdown-details">{{personDetails?.company?.telephone}}</p>
          } @else {
            <input
              type="tel"
              value=""
              formControlName="companyTelephone"
              class="app-profile-general-dropdown-input-details app-selected"
              aria-describedby="app-view-profile-company-phone-error-message"
              id="app-view-profile-company-telephone">
          }
          @if (profileForm.controls['companyTelephone'].errors) {
            <mat-error class="app-error-message" role="alert" id="app-view-profile-company-phone-error-message">
              {{ 'APP.EDIT_PROFILE.INVALID_INPUT' | translate }}
            </mat-error>
          }
        </div>
        <mat-divider class="app-general-dropdown-divider" />
        <div class="app-general-dropdown-details">
          <label
            class="app-profile-general-dropdown-heading"
            for="app-view-profile-company-email">
            {{'APP.EDIT_PROFILE.EMAIL' | translate}}
          </label>
          @if (contactSectionButtonsToggle) {
             <p class="app-profile-general-dropdown-details">{{personDetails?.company?.email}}</p>
          } @else {
            <input
              type="text"
              value=""
              formControlName="companyEmail"
              class="app-profile-general-dropdown-input-details app-selected"
              aria-describedby="app-view-profile-company-email-error-message"
              id="app-view-profile-company-email">
          }
          @if (profileForm.controls['companyEmail'].errors) {
            <mat-error class="app-error-message" role="alert" id="app-view-profile-company-email-error-message">
              {{ 'APP.EDIT_PROFILE.INVALID_INPUT' | translate }}
            </mat-error>
          }
        </div>
      </div>
    }
  </div>
  @for (section of sections; track $index) {
    <adf-dynamic-component [id]="section.component"/>
  }
</div>
